import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { QueriesClientService } from "@rightship-tech/common-ui/services/queries/queries-client.services";
import { autoinject } from "aurelia-framework";

@autoinject
export class AuditsApi {

    public platformUrl: string = `${this.configService.config.urls.rightShipPlatformApiUrl}`

    constructor(private queriesClientService: QueriesClientService, private configService: ConfigService) { }

    public getDocumentAudits(documentId: number, documentTypeId: number): Promise<any> {
        return this.queriesClientService.getData(`${this.platformUrl}/odata/RightShipAudits/Genesis.GetAudits(entityTypeId=${documentTypeId},entityId=${documentId})?$orderby=timestamp desc`);
    }
}
